'use strict';

var React = require('react');
var header = require('./Cells/header.js');
require('../Tooltip/component.js');
require('../Icon/component.js');
require('./Cells/headerIcon.styles.js');
var cell = require('./Cells/cell.js');
require('./Cells/cellCheckbox.styles.js');
require('../forms/Select/Control.js');
require('../forms/Select/Option.js');
require('./Cells/cellSelect.styles.js');
require('../forms/Switch/component.js');
require('./Cells/cellSwitch.styles.js');
require('../Text/component.js');
require('./Cells/cellSubText.styles.js');
require('../Pill/pill.styles.js');
require('../Pill/pillButton.styles.js');
require('./Cells/cellPill.styles.js');
require('../Chip/component.js');
require('./Cells/cellChip.styles.js');
require('../Tag/component.js');
require('./Cells/cellTag.styles.js');
require('./Cells/cellActions.js');
var cellIcon = require('./Cells/cellIcon.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function useExpandableRow(engine, withExpandableRow, getRowOptions) {
    const [columnsWithExpandable, setColumnsWithExpandable] = React.useState([]);
    const [colSizeWithExpandable, setColSizeWithExpandable] = React.useState({});
    const factoryHandleExpanded = (d) => (e) => {
        engine.expandedUnexpanded(d[engine.keyField]);
        e.preventDefault();
    };
    const shouldDisplayCellIcon = React.useMemo(() => (data) => {
        if (getRowOptions) {
            return getRowOptions(data)?.expandable;
        }
        return true;
    }, [getRowOptions]);
    React.useEffect(() => {
        if (withExpandableRow) {
            setColumnsWithExpandable([
                {
                    key: 'expanded',
                    headerCustom: headerProps => React__default.default.createElement(header.Header, { ...headerProps, resize: { enable: false } }),
                    cell: cellProps => (React__default.default.createElement(React__default.default.Fragment, null, shouldDisplayCellIcon(cellProps.data) ? (React__default.default.createElement(cellIcon.CellIcon, { name: engine.state.expandedRows.includes(cellProps.data[engine.keyField]) ? 'down-filled' : 'next-filled', onClick: factoryHandleExpanded(cellProps.data), ...cellProps })) : (React__default.default.createElement(cell.Cell, { ...cellProps })))),
                    width: '50px',
                },
            ]);
            setColSizeWithExpandable({ expanded: '50px' });
        }
    }, [withExpandableRow, engine.state.expandedRows]);
    return { columnsWithExpandable, colSizeWithExpandable };
}

exports.useExpandableRow = useExpandableRow;
//# sourceMappingURL=useExpandableRow.js.map
